export default {
  items: [
    {
      title: true,
      name: 'Fahrzeugverwaltung',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Gebiete',
      url: '/vehicles/areas',
      icon: 'icon-drop'
    },
    {
      name: 'Fahrer',
      url: '/vehicles/drivers',
      icon: 'icon-drop'
    },
    {
      name: 'Fahrzeuge',
      url: '/vehicles/list',
      icon: 'icon-drop'
    },
    {
      divider: true
    },
    {
      title: true,
      name: 'Extras'
    },
    {
      name: 'Pages',
      url: '/pages',
      icon: 'icon-star',
      children: [
        {
          name: 'Login',
          url: '/pages/login',
          icon: 'icon-star'
        },
        {
          name: 'Register',
          url: '/pages/register',
          icon: 'icon-star'
        },
        {
          name: 'Error 404',
          url: '/pages/404',
          icon: 'icon-star'
        },
        {
          name: 'Error 500',
          url: '/pages/500',
          icon: 'icon-star'
        }
      ]
    },
  ]
}
